import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {RolesApi} from '.';

const rolesApi = new RolesApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const getRoles = () =>
  withCancellation(cancelToken => rolesApi.rolesGet('1', 'EnrollTrackRole', getAxiosConfig(cancelToken))).then(
    handleResponse
  );

export default {
  getRoles,
};
